<div class="kt-header__brand   kt-grid__item" id="kt_header_brand">
    <div class="kt-header__brand-logo">
        <a routerLink="/" target="_blank">
            <img *ngIf="!appSession.tenant || !appSession.tenant.logoId" src="/assets/common/images/app-logo-on-dark.svg" alt="logo" height="38" class="kt-header__brand-logo-default" />
            <img *ngIf="!appSession.tenant || !appSession.tenant.logoId" src="/assets/common/images/app-logo-on-light.svg" alt="logo" height="38" class="kt-header__brand-logo-sticky" />
            <img *ngIf="appSession.tenant && appSession.tenant.logoId" [src]="remoteServiceBaseUrl + '/TenantCustomization/GetTenantLogo?skin=' + currentTheme.baseSettings.menu.asideSkin + '&tenantId=' + appSession.tenant.id + '&id=' + appSession.tenant.logoId" alt="logo" height="38" />
        </a>
    </div>
</div>
